export const CHART_COLORS = {
    largeCap: "#F58D91",
    midCap: "#F9E289",
    smallCap: "#8BDBCD",
};

export const LEGEND_PAYLOAD = [
    { value: "Large Cap", color: CHART_COLORS.largeCap },
    { value: "Mid Cap", color: CHART_COLORS.midCap },
    { value: "Small Cap", color: CHART_COLORS.smallCap },
];

export const COLORS = [
    "#F58D91",
    "#40CDFA",
    "#F9E289",
    "#BBBEFF",
    "#CEC7B6",
    "#DD98D7",
    "#A9A9A9",
    "#E0F35B",
    "#FFCAA6",
    "#8E9FFC",
    "#85CCFF",
    "#9DFFAF",
    "#66F3E8",
    "#C8CFAE",
    "#ECCA9C",
    "#9CB6DD",
    "#FFD0EC",
];
